import axios from "axios";
// import { auth } from '../firebase_connection/firebase'

const customInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
customInstance.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");

    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers["Access-Control-Allow-Origin"] = "*";
    return config;
  }
  return config;
});

export default customInstance;
